/**
 * Módulo de ubicaciones — CRUD con lista y consulta de equipos por ubicación y fecha
 */

import { createCrudMethods } from '../base/crudMethods';

/**
 * Crea el módulo de ubicaciones
 *
 * @param {Object} deps - Dependencias inyectadas
 * @param {Function} deps.authenticatedRequest - Función de request autenticada
 * @returns {Object} Métodos del módulo ubicaciones
 */
export function createUbicacionesModule({ authenticatedRequest }) {
  return {
    ...createCrudMethods(
      {
        endpoint: '/api/ubicaciones',
        entityName: 'ubicacion',
        entityNamePlural: 'ubicaciones',
        methods: { lista: true },
        methodNames: { getById: 'getUbicacion' }
      },
      { authenticatedRequest }
    ),

    /**
     * Obtiene equipos en una ubicación específica
     *
     * @param {number} ubicacionId - ID de la ubicación
     * @param {string} [fecha] - Fecha en formato YYYY-MM-DD (default: hoy)
     * @returns {Promise<{success: boolean, data: Array}>}
     */
    async getEquiposEnUbicacion(ubicacionId, fecha) {
      const params = fecha ? `?fecha=${fecha}` : '';
      return await authenticatedRequest(`/api/ubicaciones/${ubicacionId}/equipos${params}`);
    }
  };
}
